import React, { useRef, useState } from "react";
import T from "prop-types";
import { Overlay, Tooltip } from "react-bootstrap";
import { connect } from "react-redux";
import { create, destroy } from "APP_ROOT/Nav/BookmarkedParts/actions";
import { BOOKMARKS } from "MODULES/users/constants";
import { isArray } from "lodash";

function Pin({ bookmarks, createBookmark, partId, removeBookmark }) {
  const [show, setShow] = useState(false);

  const ref = useRef();

  const isPinned = bookmarks.map(p => p.part.id).includes(partId);
  const [text, setText] = useState("");
  const handleTooltip = () => {
    const method = isPinned ? removeBookmark : createBookmark;
    setText(isPinned ? "Removed!" : "Bookmarked!");
    method(partId).then(() => {
      setShow(true);
    });
  };

  const handleCloseTooltip = () => {
    setTimeout(() => {
      setShow(false);
    }, 900);
  };

  return (
    <React.Fragment>
      <i
        className="fa fa-thumb-tack fa-xs pointer"
        style={{
          transform: "rotate(45deg)",
          margin: "0px 5px",
          color: isPinned ? "#3d8b40" : ""
        }}
        ref={ref}
        onClick={handleTooltip}
      />
      <Overlay
        target={ref.current}
        show={show}
        placement="top"
        onEntered={handleCloseTooltip}
      >
        <Tooltip>{text}</Tooltip>
      </Overlay>
    </React.Fragment>
  );
}

export default connect(
  state => {
    const bookmarks = state.session.get(BOOKMARKS).toJS();
    return {
      bookmarks: isArray(bookmarks) ? bookmarks : []
    };
  },
  dispatch => ({
    createBookmark: partId => dispatch(create(partId)),
    removeBookmark: partId => dispatch(destroy(partId))
  })
)(Pin);

Pin.propTypes = {
  bookmarks: T.arrayOf(T.shape({})),
  createBookmark: T.func.isRequired,
  removeBookmark: T.func.isRequired,
  partId: T.number.isRequired
};



// WEBPACK FOOTER //
// ./app/modules/parts/components/Detail/Pin.jsx